import { compileRoutes } from "@workflows/runtime-web";

export const routes = compileRoutes({
  "tasks.index": (_?: unknown) => "/tasks",
  "task.index": (_: { taskId: string }) => "/tasks/:taskId",
});
